import {
  LOGIN_RESPONSE,
  API_STATUS,
  PATIENT_TICKER_RESPONSE,
  USER_DATA_RES,
  LOGOUT_RES,
} from './login.types'

/**
 * @fileOverview Manages the response of action
 * @author Athul George <athul@trillium-technologies.com>
 * @author  Akhil Francis <akhil@trillium-technologies.com>
 * @author Cinu James <cinu@trillium-technologies.com>
 * @example switch (action.type) {
    case TYPE_NAME: {
      return {
        ...state,
        ...{INITIAL_STATE: action.payload },
      }
    }
    }
 */

const INITIAL_STATE = {
  status: false,
  login: false,
  loginResponse: {},
  patientTicker: {},
  userdata: null,
  logout: null,
}

/**
 *
 * @param state - global state management
 * @param action - contains type and payload
 * @returns {{loginResponse: {}, login: boolean, status: boolean}|{loginResponse: *, login: boolean, status: boolean}|{loginResponse: {}, login: boolean, status: *}}
 */

const loginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_RESPONSE: {
      return { ...state, ...{ login: true, loginResponse: action.payload } }
    }
    case API_STATUS: {
      return { ...state, ...{ status: action.payload } }
    }
    case PATIENT_TICKER_RESPONSE: {
      return { ...state, ...{ patientTicker: action.payload } }
    }
    case USER_DATA_RES: {
      return { ...state, ...{ userdata: action.payload } }
    }
    case LOGOUT_RES: {
      return { ...state, ...{ logout: action.payload } }
    }
    default:
      return state
  }
}
export default loginReducer
